module.exports = require("difflib");